import type { FC } from 'react';
import { StackedLinkGroup } from '../StackedLinkGroup';
import { useExperienceLinks } from './useExperienceLinks';

export const StackedExperienceLinks: FC = () => {
    const { data: props, isLoading } = useExperienceLinks();

    if (isLoading || !props) return null;

    return <StackedLinkGroup {...props} />;
};
